import '~/scripts/integrations/jquery-extended';

window.R.BadgesRemaining = (function() {
  var BadgesRemaining = function($listWrapper) {
    this.$listWrapper = $listWrapper;
    this.renderBadgeLimits();
    this.addEvents();
  };

  function removedUser() {
    settingQuantityCount(1);
  }

  function removedTeam($el) {
    var count = parseInt($el.parent().data("count") || 0);
    settingQuantityCount(count);
  }

  function addedUser() {
    settingQuantityCount(-1);
  }

  function settingQuantityCount(num) {
    var $badgeQuantity = $('#badgesLeftAtInterval');

    if ($badgeQuantity.text() == ''){
      return;
    }

    var currentQuantity = parseInt($badgeQuantity.data('quantity'))
    var newQuantity = currentQuantity + num;
    $badgeQuantity.data('quantity', newQuantity)
    let formattedNewQuantity = newQuantity.toLocaleString(navigator.language);
    window.R.BadgesRemaining.setOriginalButtonInBadgeList(formattedNewQuantity);

    let formattedCurrentQuantity = parseInt(currentQuantity).toLocaleString(navigator.language);
    let subtractedTextWithInterval = $badgeQuantity.text().replace(formattedCurrentQuantity, formattedNewQuantity);
    $badgeQuantity.text(subtractedTextWithInterval);

    if (newQuantity < 0) {
      $badgeQuantity.addClass("text-danger");
    } else {
      $badgeQuantity.removeClass("text-danger");
    }
  }

  function addedTeam(team) {
    settingQuantityCount(-(gon.team_counts[team.id]) || 0);
  }

  BadgesRemaining.prototype.addEvents = function() {
    $document.on("addedRecipient", function(event, recipient) {
      var type = recipient.type.toLowerCase();

      if (type === "team") {
        addedTeam(recipient);
      } else  {
        addedUser();
      }
    });

    $document.on("removedRecipient", function(event, isTeam, $el) {
      if (isTeam) {
        removedTeam($el);
      } else {
        removedUser();
      }
    });
  };

  BadgesRemaining.prototype.renderBadgeLimits = function(callback) {
    var endpoint = this.$listWrapper.data('badgesRemainingEndpoint');
    $.get(endpoint, function(data){
      this.badgeData = data.badges;
      this.addQuantities();
    }.bind(this));
  };

  BadgesRemaining.prototype.addQuantities = function() {
    var that = this;

    this.$listWrapper.find("li.badge-item").each(function(){
      var $badgeItem = $(this);
      var id = $badgeItem.data('badgeId');

      if(!id || !that.badgeData[id]) {
        return;
      }

      var label = that.badgeData[id].quantity_with_interval_text;
      var quantity = that.badgeData[id].quantity;
      var interval = that.badgeData[id].interval_noun;
      var maxPointsLabel = that.badgeData[id].badge_with_diff_min_max;

      $badgeItem.attr('data-quantity', quantity);
      $badgeItem.attr('data-display', maxPointsLabel);
      $badgeItem.attr('data-interval', interval);
      $badgeItem.find('.badges-remaining-wrapper').attr("data-badgeid", id).html(label);
    });

    $(".badge-loader").hide();
  };

  BadgesRemaining.setOriginalButtonInBadgeList = function(quantity) {
    var id = $(".recognition-points-with-badge-quantity .badges-remaining-wrapper").data("badgeid");
    var $button = $("#badge-item-"+id);

    quantity = quantity || $button.data("quantity");
    if(quantity){
      $button.find(".badge-quantity").text(quantity.toLocaleString(navigator.language));
    }
  };

  return BadgesRemaining;
})();
